export default __webpack_public_path__ + "fcfbc1bc238f84cc11a38da58b2e41ae.png";